import {
  facebook,
  instagram,
  twitter,
  image1,
  image2,
  image3,
  step1,
  step2,
  step3,
} from "../assets";

export const navLinks = [
  {
    id: "benefits",
    title: "Benefits",
  },
  {
    id: "How-to-works",
    title: "How to works",
  },
  {
    id: "reviews",
    title: "Reviews",
  },
  {
    id: "faq",
    title: "FAQ",
  },
  {
    id: "affiliate",
    title: "Affiliate",
  },
];
export const socialMedia = [
  {
    id: "social-media-1",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-2",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-3",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
];

export const menuItems = [
  {
    value: "20",
    title: "20",
  },
  {
    value: "30",
    title: "30",
  },
  {
    value: "40",
    title: "40",
  },
];

export const infoData = [
  {
    title: "Anonymous",
    body: "We want to guarantee the right to anonymity because we believe it is a fundamental right. To do this, we will never ask you for personal data. You don’t need to do KYC, nor do you need to create an account on our site.",
    image: image1,
  },
  {
    title: "Quick and Convenient",
    body: "with Titanex, there is no limit to the amount you can transfer, you can exchange any amount you want at a fixed rate, In general, transactions are executed in less than 15 minutes for ERC BSC and TRC tokens.",
    image: image2,
  },
  {
    title: "Peace of mind",
    body: "You can make your transactions without stress because your funds will NEVER be blocked, frozen and we will never ask you for more persoanl information, No blacklist - proof of funds",
    image: image3,
  },
];

export const steps = [
  {
    title: "Step 1",
    body: "Choose the pair you want to exchange.",
    image: step1,
  },
  {
    title: "Step 2",
    body: "Provide your addresses and send your cryptos to Titanex.",
    image: step2,
  },
  {
    title: "Step 3",
    body: "After a few minutes. receive your funds directly to your address",
    image: step3,
  },
];

export const testimonials1 = [
  {
    image: null,
    name: 'Bill Kiaubaer',
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Allan Sanidad",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Markus",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Brooklyn Simmons",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
]

export const testimonials2 = [
  {
    image: null,
    name: 'Wade Warren',
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Douglas Coffman",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Salahdine Benyoussef",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
  {
    image: null,
    name: "Jane Cooper",
    body:"“Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.”"
  },
]

export const faq = [
  {
    title: "What is the difference between Titanex and the other exchange ?",
    content:"Titanex guarantees privacy and anonmity for left funds and that your funds will NEVER be blocked. forzen and we will never ask you for more peronal information. Our goal is also to not have our customers’ addresses blacklisted after using Titanex.Like it happedn to Tornado?"
  },
  {
    title: "Do I need dto do a KYC  to use Titanexf?",
    content:"Titanex guarantees privacy and anonmity for left funds and that your funds will NEVER be blocked. forzen and we will never ask you for more peronal information. Our goal is also to not have our customers’ addresses blacklisted after using Titanex.Like it happedn to Tornado?"
  },
  {
    title: "I need proof of  funds after using Titanex, how can I get this document?",
    content:"Titanex guarantees privacy and anonmity for left funds and that your funds will NEVER be blocked. forzen and we will never ask you for more peronal information. Our goal is also to not have our customers’ addresses blacklisted after using Titanex.Like it happedn to Tornado?"
  },
  {
    title: "What are the fees to use Titanex ",
    content:"Titanex guarantees privacy and anonmity for left funds and that your funds will NEVER be blocked. forzen and we will never ask you for more peronal information. Our goal is also to not have our customers’ addresses blacklisted after using Titanex.Like it happedn to Tornado?"
  },
  {
    title: "What can we do for you?",
    content:"Titanex guarantees privacy and anonmity for left funds and that your funds will NEVER be blocked. forzen and we will never ask you for more peronal information. Our goal is also to not have our customers’ addresses blacklisted after using Titanex.Like it happedn to Tornado?"
  },
]

export const footerLinks = [
  {
    id: "termsof-use",
    title: "Termsof use",
  },
  {
    id: "privacy-policy",
    title: "Privacy Policy",
  },
  {
    id: "kyc-aml",
    title: "KYC/AML",
  },
];